<template>
  <div class="contents wrap" id="skipToContents">
    <slot />
  </div>
</template>

<script>
export default {
  name: "SubLayout",
  components: {},
  created() {},
  methods: {},
};
</script>
